import { useState, useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router';

import { findRoutByURL } from './helper';
import type { IRouteModel, TGoto } from './types';

const initialValue = {
  location: {} as Location,
  data: {} as IRouteModel,
};

export type TLocationDetails = typeof initialValue;

export function useLocationDetails() {
  const location = useLocation();
  const [data, setData] = useState(initialValue);

  useEffect(() => {
    setData({ location: location as unknown as Location, data: findRoutByURL(location.pathname) });
  }, [location]);

  return data;
}

export function useNav(): TGoto {
  const nav = useNavigate();
  return (route: IRouteModel | number | string, replace = false, state = {}) => {
    if (typeof route === 'number') nav(route);
    else nav(typeof route === 'object' ? route?.link : route, { replace, state });
  };
}
